// ©2024 Austin App House. All rights reserved.
import React from 'react';
// eslint-disable-next-line import/no-cycle
import Content from '../../components/templates/Content';
import { Link } from 'react-router-dom';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';

const Templates = ({ mainContainer }) => (
  <div className="subpage-wrap">
    <div className="subpage-header">
      <h1 className="subpage-title">Templates</h1>
      <Link className="subpage-btn subpage-btn--mint" to="/create-work-order-template">
        <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
        Add Template
      </Link>
    </div>
    <div className="subpage-table-scroll">
      <Content />
    </div>
  </div>
);

export default Templates;
